<script>
export default {
  methods: {},
  props: {
    default: Boolean,
    checked: Boolean,
    checkWatch: Boolean,
    variant: [Array, Object],
    error: Boolean,
  },
  data: function () {
    return {
      value: false,
    };
  },
  computed: {},
  mounted: function () {
    this.value = this.default;
    if (this.checkWatch) {
      this.$watch("checked", (value) => {
        this.value = value;
      });
    }
  },
  methods: {
    click: function () {
      this.value = !this.value;
      this.$emit("update:checked", this.value);
    },
  }
};
</script>
    
<template>
  <div
    class="f-checkbox"
    @click.stop="click($event)"
    :class="[variant, { error }]"
  >
    <div class="f-checkbox-container">
      <input type="checkbox" v-model="value" />
    </div>
    <div class="f-checkbox-label" v-if="$slots.default"><slot></slot></div>
  </div>
</template>

<style lang="scss">
.f-checkbox {
  display: flex;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px 4px;

  // simple variant
  &.simple {
    padding: 0;
    &:hover,
    &:hover:active {
      background-color: transparent;
    }
  }

  &.error {
    .f-checkbox-container {
      input {
        border-color: #d00e0e;
      }
    }

    .f-checkbox-label {
      color: #d00e0e;
    }
  }

  .f-checkbox-container {
    input {
      /* Add if not using autoprefixer */
      -webkit-appearance: none;
      /* Remove most all native input styles */
      appearance: none;
      /* For iOS < 15 */
      background-color: var(--form-background);
      /* Not removed via appearance */
      margin: 0;
      padding: 0;
      cursor: pointer;

      font: inherit;
      color: #1890d3;
      width: 20px;
      height: 20px;
      border: 2px solid #1890d3;
      border-radius: 4px;
      transform: translateY(-0.075em);

      display: grid;
      place-content: center;

      &::before {
        content: "";
        width: 10px;
        height: 10px;
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
        transform: scale(0);
        transform-origin: bottom left;
        transition: 120ms transform ease-in-out;
        background-color: white;
      }

      &:checked {
        background-color: #1890d3;
        color: white;
        &::before {
          transform: scale(1);
        }
      }
    }
  }
  .f-checkbox-label {
    margin-left: 8px;
    display: flex;
    align-items: center;
    gap: 7px;
    color: #161615;
  }

  &:hover {
    background-color: rgba(24, 144, 211, 0.1);
  }

  &:hover:active {
    background-color: rgba(24, 144, 211, 0.25);
  }

  &.negative {
    .f-checkbox-container input {
      border: 2px solid var(--statusNegative);
    }
  }
}

.dark-mode {
  .f-checkbox {
    // simple variant
    &.simple {
      padding: 0;
      &:hover,
      &:hover:active {
      }
    }

    &.error {
      .f-checkbox-container {
        input {
          border-color: var(--negative);
        }
      }

      .f-checkbox-label {
        color: var(--negative);
      }
    }

    .f-checkbox-container {
      input {
        font: inherit;
        color: #1890d3;
        border: 2px solid #1890d3;

        &::before {
        }

        &:checked {
          background-color: var(--navigation);
          &::before {
            transform: scale(1);
          }
        }
      }
    }
    .f-checkbox-label {
      color: var(--white-a75);
    }

    &:hover {
      background-color: rgba(24, 144, 211, 0.1);
    }

    &:hover:active {
      background-color: rgba(24, 144, 211, 0.25);
    }

    &.negative {
      .f-checkbox-container input {
        border: 2px solid var(--negative);
      }
    }
  }
}
</style>